export default __webpack_public_path__ + "static/media/tuffHammerPics3.db453718.jpeg";